/* KAAFEY v7 — header blijft bereikbaar: vast bovenin na de hero, verdwijnt in het scrollverhaal en bij naar beneden scrollen op mobiel */
(() => {
  const h = document.querySelector('.site-header');
  if (!h) return;
  const journey = document.querySelector('.journey');
  let last = scrollY, tick = false;
  const run = () => {
    tick = false;
    const y = scrollY;
    const stuck = y > 140;
    h.classList.toggle('is-stuck', stuck);
    let hide = false;
    if (journey) { const r = journey.getBoundingClientRect(); if (r.top <= 0 && r.bottom >= innerHeight) hide = true; }
    if (stuck && innerWidth <= 760 && y > last + 6 && y > 500) hide = true;
    if (!stuck) hide = false;
    if (hide) h.classList.add('is-hidden');
    else if (y < last - 6 || !stuck || innerWidth > 760) h.classList.remove('is-hidden');
    last = y;
  };
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', run, { passive: true });
  run();
})();
/* winkelwagen-teller bijwerken na toevoegen vanuit de accessoireset */
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-kset-add]')) return;
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  setTimeout(() => fetch(base + 'cart.js').then((r) => r.json()).then((c) => {
    const a = document.querySelector('.header-cart'); if (!a) return;
    let n = a.querySelector('.header-cart-count');
    if (!n) { n = document.createElement('span'); n.className = 'header-cart-count'; a.appendChild(n); }
    n.textContent = c.item_count;
  }).catch(() => {}), 1200);
});
